import {
  useDeleteKey,
  useGetAuthKeys,
  useGetFiltersAuthKeys
} from "@/api/useAuthKeys"
import { AuthKeyType } from "@/api/useAuthKeys.types"
import { useQueryString } from "@/hooks/useQueryString"
import { useTranslation } from "@/hooks/useTranslation"
import { useRef, useState } from "react"
import { wrapFn } from "../../helpers/applications"
import {
  getAuthKeysData,
  getFiltersAuthKeysSelector,
  getFiltersKeys
} from "./useAuthKeys.selector"

import type { FilterAuthKeysResponse } from "@/api/useAuthKeys.types"

export const useAuthKeys = (
  needle: AuthKeyType,
  config?: { enabled: boolean }
) => {
  const [loading, setLoading] = useState(false)
  // the keys lists aren't paged or searched: they take only their filters and sort
  const {
    pageNumber: _pageNumber,
    query: _query,
    ...params
  } = useQueryString([...getFiltersKeys(), "orderBy", "ascending"])
  const context = useGetAuthKeys(needle, params, {
    select: getAuthKeysData,
    ...(config || {})
  })

  const { mutateAsync: mutateDeleteKey } = useDeleteKey(needle)

  const deleteKey = wrapFn(async (keyId: string) => {
    await mutateDeleteKey(keyId)
  }, setLoading)

  return [context, { loading, deleteKey }] as const
}

export const useFiltersAuthKeys = (needle: AuthKeyType) => {
  const { t } = useTranslation()
  const select = useRef((response: FilterAuthKeysResponse) =>
    getFiltersAuthKeysSelector(response, t)
  ).current
  const context = useGetFiltersAuthKeys(needle, {}, { select })

  return context
}

export type AuthKeysTabData = ReturnType<typeof getAuthKeysData>["data"]

export type AuthKey = AuthKeysTabData[number]
